<template>
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20">
    <path d="M10 20a10 10 0 110-20 10 10 0 010 20zm6.95-10L6.44 4.745v10.51z" clip-rule="evenodd"/>
</svg>
</template>

<script>
export default {

}
</script>
